import {findClosestElementByClass} from "../helpers/dom/closest";
import {scrollToRelativeElement} from "../helpers/dom/scroll";

export const pricingSimulator = {
	init: function() {
		if (!document.querySelector(".pricing-simulator")) return;

		pricingSimulator.setHeightOfScrollArea();
		pricingSimulator.addShortListNameClickListener();
		pricingSimulator.addShortListCheckboxClickListener();
		pricingSimulator.addLongListCheckboxClickListener();
		pricingSimulator.countNumberOfChannels(document.querySelector(".pricing-simulator"));
		pricingSimulator.countPrice(document.querySelector(".pricing-simulator"));
	},

	setHeightOfScrollArea: function() {
		const simulator = document.querySelector(".pricing-simulator");

		if (!simulator) return;

		const bodyHeight = simulator.clientHeight -
		(simulator.querySelector(".pricing-simulator__header").clientHeight
		+ simulator.querySelector(".pricing-simulator__footer").clientHeight);
		document.querySelector(".pricing-simulator__short-list").style.height = bodyHeight + "px";
		document.querySelector(".pricing-simulator__long-list").style.height = (bodyHeight - simulator.querySelector(".channels-popup__tabs").clientHeight) + "px";
	},

	addShortListNameClickListener: function() {
		const shortListNames = document.querySelectorAll(".short-list__name");
		if (shortListNames == null) return;

		shortListNames.forEach(name => {
			name.addEventListener("click", pricingSimulator.scrollToLongListPackage)
		})
	},

	addShortListCheckboxClickListener: function() {
		const shortListNames = document.querySelectorAll("button.short-list__checkbox");
		if (shortListNames == null) return;

		shortListNames.forEach(name => {
			name.addEventListener("click", pricingSimulator.scrollToLongListPackage);
			name.addEventListener("click", function() {				
                const id = findClosestElementByClass(this, "short-list").getAttribute("data-short-name");
                const disallow = findClosestElementByClass(this, "short-list").getAttribute("data-disallow");
				pricingSimulator.selectBoxes(this, id, disallow);
			})
		})
	},

	scrollToLongListPackage: function() {
		pricingSimulator.changeTab('.action-tab__tabs .action-tab__tab');
		const parentSimulator = findClosestElementByClass(this, "pricing-simulator");
		const longListContainer = parentSimulator.querySelector(".pricing-simulator__long-list");
		const shortListContainer = findClosestElementByClass(this, "short-list");
		const id = shortListContainer.getAttribute("data-short-name");
		const longListElement = parentSimulator.querySelector("[data-long-name='"+id+"']")
		scrollToRelativeElement(longListContainer, longListElement)
	},

	selectBoxes: function (that, id, disallow) {
		const parentSimulator = findClosestElementByClass(that, "pricing-simulator");
		const shortListElement = parentSimulator.querySelector("[data-short-name='"+id+"']");
		shortListElement.classList.toggle("selected");
		const longListElement = parentSimulator.querySelector("[data-long-name='"+id+"']");
        longListElement.classList.toggle("selected");
        
        const disallowElements = parentSimulator.querySelectorAll("[data-disallow='"+disallow+"']");
        disallowElements.forEach(element => {
            const elementId = element.getAttribute('data-short-name') || element.getAttribute('data-long-name');
            const elementDisallow = element.getAttribute('data-disallow');
            if (elementId !== id && elementDisallow === disallow) {
                element.classList.remove("selected");
            }            
		})		

		pricingSimulator.countNumberOfChannels(parentSimulator);
		pricingSimulator.countPrice(parentSimulator);
	},

	addLongListCheckboxClickListener: function() {
		const longListNames = document.querySelectorAll("button.long-list__checkbox");
		if (longListNames == null) return;

		longListNames.forEach(name => {
            name.addEventListener("click", pricingSimulator.scrollToShortListPackage);
			name.addEventListener("click", function() {
                const id = findClosestElementByClass(this, "long-list").getAttribute("data-long-name");
                const disallow = findClosestElementByClass(this, "long-list").getAttribute("data-disallow");
				pricingSimulator.selectBoxes(this, id, disallow);
			})
		})
    },
    scrollToShortListPackage: function() {
		const parentSimulator = findClosestElementByClass(this, "pricing-simulator");
		const shortListContainer = parentSimulator.querySelector(".pricing-simulator__short-list");
		const longListContainer = findClosestElementByClass(this, "long-list");
		const id = longListContainer.getAttribute("data-long-name");
		const shortListElement = parentSimulator.querySelector("[data-short-name='"+id+"']")
		scrollToRelativeElement(shortListContainer, shortListElement)
	},

	countNumberOfChannels: function(parentSimulator) {
		const channels = parentSimulator.querySelectorAll(".long-list.selected .long-list__logo");
		const channelNames = Array.from(channels).map(c => c.getAttribute("data-channel"));
		const uniqueChannels = [...new Set(channelNames)];

		const HDChannelNames = Array.from(channels)
		.filter(c => c.getAttribute("data-hd")=="true")
		.map(c => c.getAttribute("data-channel"));
		const uniqueHDChannels = [...new Set(HDChannelNames)];

		pricingSimulator.setNumberOfChannels(parentSimulator, uniqueChannels.length, uniqueHDChannels.length);
	},  

	setChannelsStr: function(amount) {   
		const simulator = document.querySelector(".pricing-simulator");
		const channelsStr = simulator.querySelector("[data-channelsStr]")
		
		const channelsNames = channelsStr.getAttribute("data-channelsStr");
		const channelsArr = channelsNames.split(',') //kanał,kanały,kanałów            
	  

		if(amount === 1) {
			return channelsArr[0]            
		} else 
			if (amount % 10 >= 2 && amount % 10 <= 4 && (amount % 100 < 10 || amount % 100 >= 20)) {
				return channelsArr[1]
			} else {
				return channelsArr[2]
			}
	   
	   
	},

	setNumberOfChannels: function(simulator, numberOfChannels, numberOfHDChannels) {
		simulator.querySelector(".channelsCount").innerHTML = numberOfChannels;
		simulator.querySelector(".channelsHDCount").innerHTML = numberOfHDChannels;          
		simulator.querySelector("[data-channelsStr]").innerHTML = pricingSimulator.setChannelsStr(numberOfChannels);
	},

	countPrice: function(simulator) {
		const selectedPackages = simulator.querySelectorAll(".long-list.selected");
		const prices = Array.from(selectedPackages).map(c => parseFloat(c.getAttribute("data-price")));
		let sum = prices.reduce(function(a, b) {
			return a+b;
		});
		sum = pricingSimulator.roundNumber(sum, 2);
		// console.log('selectedPackages', selectedPackages);
		// console.log('prices', prices);		

		pricingSimulator.countMinValue(simulator, sum);
		pricingSimulator.countDiscount(simulator, sum);
	},

	setPrice: function(simulator, sum) {
		const sumToString = sum.toString();
		// console.log('sum', sum);
		// console.log('sumToString', sumToString);
		const parsedString = "<big>" + sumToString.split(".")[0]+ ",</big>"+ (sumToString.split(".")[1] || "00");
		simulator.querySelector(".orderSum").innerHTML = parsedString;
	},

	countMinValue: function(simulator, sum) {
		const minElement = simulator.querySelector(".minOrderPrice");
		const minValue = minElement.getAttribute("data-min-price");
		const difference = pricingSimulator.roundNumber(minValue - sum, 2);
		const buttonElement = simulator.querySelector(".pricing-simulator__button");
		const footerElement = simulator.querySelector(".pricing-simulator__footer");
		if(difference <= 0) {
            minElement.parentElement.style.display = "none";
            // console.log('simulator', simulator, simulator.hasAttribute('data-order'));
            if (simulator.hasAttribute('data-order')) {
                buttonElement.classList.add("active");
            }			
			footerElement.classList.add("active")
		}
		else {
			minElement.parentElement.style.display = "block";
			minElement.innerHTML = difference.toString().replace(".", ",");
			buttonElement.classList.remove("active");
			footerElement.classList.remove("active");
		}
	},

	countDiscount: function(simulator, sum) {
		const discountElement = simulator.querySelector(".minDiscountPrice");
		const discountPrice = discountElement.getAttribute("discount-price");
		const discountValue = discountElement.getAttribute("discount-value");
		const remainingValue = discountPrice - sum;

		if(sum >= discountPrice) {
			sum = sum - discountValue;
		}

		pricingSimulator.setPrice(simulator, pricingSimulator.roundNumber(sum, 2));

		if(remainingValue <= 0) {
			pricingSimulator.setAppliedDiscountMessage(simulator);
		}
		else {
			pricingSimulator.setValueToGetDiscount(simulator, discountElement, pricingSimulator.roundNumber(remainingValue, 2));
		}
	},

	setValueToGetDiscount: function(simulator, discountElement, value) {
		simulator.querySelector(".discountNotApplied").style.display = "block";
		simulator.querySelector(".discountApplied").style.display = "none";
		discountElement.innerHTML = value;
	},

	setAppliedDiscountMessage: function(simulator) {
		simulator.querySelector(".discountNotApplied").style.display = "none";
		simulator.querySelector(".discountApplied").style.display = "none";
	},

	roundNumber: function(number, decimalPlaces) {
		const multiplayer = Math.pow(10, decimalPlaces);
		return Math.round(number * multiplayer) / multiplayer;
	},
	changeTab: function (tabSelector) {
		const simulator = document.querySelector(".pricing-simulator");
		const event = document.createEvent('Event');
		event.initEvent('click', false, true);
		const tabs = [...simulator.querySelectorAll(tabSelector)];
		const setActiveTab = tabs.find(el => {
			const dataTabValue = el.getAttribute('data-tab')
			if (dataTabValue === null || dataTabValue === '0') {
				return el;
			}
		});
		if (setActiveTab == null) return;
		setActiveTab.dispatchEvent(event);
	}

}
